import {useMediaQuery} from 'react-responsive'
import {useEffect, useState} from "react";
import {numberWithCommas, sF} from "../../utilities/NumberFormatter";
import PropTypes from "prop-types";

export function PurchaseBodyFooter(props) {
    const isDesktopOrLaptop = useMediaQuery({query: '(min-width: 1024px)'})
    const [total, setT] = useState(0);
    const [vt, setVt] = useState(0);

    useEffect(() => {
        let ttl = 0
        ttl = props.contentList.reduce((acc, item) => {
            acc += sF(item.total);
            return acc
        }, 0)

        const vatAmount = ttl * sF(props.vat) / 100
        setVt(vatAmount)
        setT(ttl + vatAmount)
    }, [props.contentList, props.vat])

    return (
        <>
            <tr>
                <th className='bg-warning border-round-md' scope="col" colSpan={4}></th>

                {isDesktopOrLaptop ? (
                    <>
                        {/* Total: directly under the Total column (same column as row's total cell) */}
                        <td
                            style={{fontSize: '1vw'}}
                            className="text-end align-content-center bg-warning"
                            scope="col"
                        >
                            <div>{numberWithCommas(total)}</div>
                        </td>

                        {/* VAT: directly under the Comment column */}
                        <td
                            style={{fontSize: '1vw'}}
                            className="text-start align-content-center bg-warning"
                            scope="col"
                        >
                            <div>{numberWithCommas(vt)}</div>
                        </td>

                        {/* Delete button column (empty in footer) */}
                        <th className='bg-warning' scope="col"></th>
                    </>
                ) : (
                    <>
                        {/* No comment column on smaller screens: show both in the Total column */}
                        <td className="text-start align-content-center" scope="col">

                            <div>{numberWithCommas(vt)}</div>

                            <div>{numberWithCommas(total)}</div>
                        </td>

                        <th className='bg-warning' scope="col"></th>
                    </>
                )}
            </tr>
        </>
    )
}

PurchaseBodyFooter.propTypes = {
    contentList: PropTypes.array.isRequired,
    vat: PropTypes.number.isRequired,
    setLoading: PropTypes.func.isRequired,
}